export const IMAGE_MAP = {
    API_ERROR: 'disputesError.svg',
    CANCEL_DISPUTE: 'cancelDisputeBanner.svg',
    CANCEL_QUESTIONNAIRE: 'cancelQuestionnaireBanner.svg',
    CANCEL: 'cancelSign.svg',
    CELEBRATE_HIGH_FIVE: 'celebrateHighFive.svg',
    CHECKMARK: 'ladyCheckmark.svg',
    CLOUD_FILE: 'cloudFile.svg',
    CONFIRMATION_BANNER: 'confirmationBanner.svg',
    CONTACT_FRAUD: 'contactFraudBanner.svg',
    CONTACT_REP: 'contactRep.svg',
    CUSTOMER_AVATAR: 'customerAvatar.svg',
    DEFAULT_BANNER: 'defaultBanner.svg',
    DIGITAL_WALLET: 'digitalWallet.svg',
    DISPUTE_ERROR: 'disputeErrorBanner.svg',
    DISPUTE_TRANSACTION: 'disputeTransaction.svg',
    ERROR: 'errorBanner.svg',
    FAQ: 'faqBanner.svg',
    FILE: 'fileFolder.svg',
    LOW_BALANCE: 'lowDisputeAmountBanner.svg',
    MAGNIFY: 'fileMagnify.svg',
    MEDIDATE_SUCCESS: 'ladyMeditateSuccess.svg',
    MEDITATE: 'ladyMeditate.svg',
    MORE_INFO: 'moreInfoNeeded.svg',
    NO_DISPUTES: 'noDisputeBanner.svg',
    REVIEW: 'reviewBanner.svg',
    SYF_AVATAR: 'synchronyAvatar.svg',
    WARNING: 'ladyWarning.svg'
};
export const getAssetUrl = (assetsHost) => new URL('assets/digital-disputes/images/', assetsHost).toString();
//# sourceMappingURL=imageRoutes.js.map